import React from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { useRecoilState } from 'recoil';

import { qrModalState } from '../../atoms/dataAtoms';
// НЕ ЗАБУДЬ ИМПОРТИРОВАТЬ КОМПОНЕНТ
import QrModal from '../components/qrModal/QrModal';

const NavigationBar = () => {
    const location = useLocation();
    const [qrModal, setQrModal] = useRecoilState(qrModalState);
    const { isAuthenticated } = useAuth();
    const history = useHistory();

    return (
        <> {/* Обернули всё во фрагмент */}
            <aside className="navigation_bar">
                <nav className="navigation_bar__container">
                    <ul className="navigation_bar__list">
                        <li className="navigation_bar__item">
                            <NavLink
                                exact
                                to="/formuls"
                                className="navigation_bar__link navigation_bar__link--formuls"
                                activeClassName="active"
                            />
                        </li>
                        <li className="navigation_bar__item">
                            <NavLink
                                to="/terms"
                                className="navigation_bar__link navigation_bar__link--terms"
                                activeClassName="active"
                            />
                        </li>

                        <li className="navigation_bar__item">
                            <NavLink
                                to="/calcs"
                                className="navigation_bar__link navigation_bar__link--calcs"
                                activeClassName="active"
                            />
                        </li>
                        <li className="navigation_bar__item">
                            <NavLink
                                to="/tables"
                                className="navigation_bar__link navigation_bar__link--tables"
                                activeClassName="active"
                            />
                        </li>

                        <li className="navigation_bar__item navigation_bar__item--settings">
                            <NavLink
                                to={{
                                    pathname: "/settings",
                                    state: { background: location }
                                }}
                                isActive={(match, location) => location.pathname === '/settings'}
                                className="navigation_bar__link navigation_bar__link--setting"
                                activeClassName="active"
                            />
                        </li>

                        {/*---QR-CODE BUTTON---*/}
                        {!isAuthenticated && (
                            <li className='navigation__link navigation__link--qr'>
                                <button
                                    className='qr-modal__qr-button'
                                    onClick={() => {
                                        setQrModal(!qrModal);
                                        // Переходим на главную, чтобы модалка
                                        // открывалась на чистом фоне, если нужно
                                        history.push('/formuls');
                                    }}
                                />
                            </li>
                        )}
                        {/*---QR-CODE BUTTON---*/}

                    </ul>
                </nav>
            </aside>

            {/* ВСТАВЛЯЕМ СЮДА: Рендерится только если qrModal === true */}
            {qrModal && <QrModal onClick={() => setQrModal(!qrModal)} />}
        </>
    );
};

export default NavigationBar;